import * as React from 'react';

import { ListMonthProps } from '../../components/list/month';
import ListDay from '../../components/list/day';

const ListMonthView: React.StatelessComponent<ListMonthProps> = props => {
    const hasEvents = props.monthData.events.allDays.length > 0;

    if (hasEvents) {
        return (
            <li className="ace-cal-list-month">
                <article className="stack-lg">
                    <h2 tabIndex={ -1 } id={`Month-List-${props.monthData.monthMoment.format("X")}`} className="ace-cal-list-month-name uppercase">{props.monthData.monthMoment.format("MMMM YYYY")}</h2>
                    <ul className="ace-cal-list-days stack-md stack-border" aria-labelledby={`Month-List-${props.monthData.monthMoment.format("X")}`}>
                        {
                            props.monthData.events.allDays.map(day => day.events.length > 0 && <ListDay key={day.date.toDateString()} day={day} />)
                        }
                    </ul>
                </article>
            </li>
        );
    } else {
        return (
            <li className="ace-cal-list-month">
                <article className="stack-lg">
                    <h2 id={`Month-List-${props.monthData.monthMoment.format("X")}`} className="ace-cal-list-month-name uppercase">{props.monthData.monthMoment.format("MMMM YYYY")}</h2>
                    <div className="ace-cal-list-days-empty" dangerouslySetInnerHTML={{ __html: props.text.emptyMonthMessaging }} aria-labelledby={`Month-List-${props.monthData.monthMoment.format("X")}`}></div>
                </article>
            </li>
        )
    }
}

export default ListMonthView;